import { IShipmentLocation } from "../shipment-location/shipment-location";
import { OrderStatus } from "../order-management/order-status";
import { BusinessLine } from "../business-lines/business-line";
import { Unit } from "../common";
import { DateTimeType } from "./delivery-time-type.enum";

export interface Schedule {
  scheduleId: number;
  scheduleDateTime: Date;
  orders: OrderSchedule[];
}

export interface OrderSchedule {
  orderId: number;
  orderCode: string;
  orderScheduleCode: string;
  orderTypeCode: string;
  purchaseOrder: string;
  shipmentLocation: IShipmentLocation;
  status: OrderStatus;
  businessLine: BusinessLine;
  totalVolume: number;
  totalLoads: number;
  isRepeatable: boolean;
  isCancellable: boolean;
  isModifiable: boolean;
  loads: Partial<LoadSchedule>[];
  hasMixedUnits: boolean;
  unit?: Unit;
}

export interface LoadSchedule {
  loadId: number;
  loadCode: string;
  loadDateTime: string;
  programmedDateTime: string;
  loadNumber: number;
  deliveryDateTime: {
    startDateTime: string;
    endDateTime: string;
    dateTimeType: DateTimeType;
  };
  items: LoadItem[];
}

export interface LoadItem {
  loadItemId: number;
  loadItemCode: string;
  quantity: number;
  product: LoadProduct;
  unit: Unit;
}

export interface LoadProduct {
  productId: number;
  productCode: string;
  productDesc: string;
  productLine: {
    productlineId: number;
    productlineCode: string;
    productlineDesc: string;
  };
}
